import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import {
  getRequiredFields,
  removeEmptyFields,
  setEmptyFieldsToNull,
} from "@/lib/utils";
import {
  CITY,
  CONTACT_NO,
  ONBOARDING_DATE,
  SCHOOL_NAME,
  STATE,
} from "./consts";
import { useIsMobile } from "@/hooks/use-mobile";
import { formValues, schema } from "./validations";
import { useEffect } from "react";

const useFilter = ({
  filterData,
  setFilterData,
  onCancel,
}: {
  filterData: any;
  setFilterData: React.Dispatch<React.SetStateAction<any>>;
  onCancel: () => void;
}) => {
  const isMobile = useIsMobile();

  const form = useForm<formValues>({
    resolver: zodResolver(schema),
    defaultValues: {
      [CITY]: "",
      [CONTACT_NO]: "",
      [ONBOARDING_DATE]: "",
      [SCHOOL_NAME]: "",
      [STATE]: "",
    },
  });

  useEffect(() => {
    if (filterData) {
      form.reset({
        [CITY]: filterData?.[CITY] || "",
        [CONTACT_NO]: filterData?.[CONTACT_NO] || "",
        [ONBOARDING_DATE]: filterData?.[ONBOARDING_DATE] || "",
        [SCHOOL_NAME]: filterData?.[SCHOOL_NAME] || "",
        [STATE]: filterData?.[STATE] || "",
      });
    }
  }, [filterData]);

  const requiredFields = getRequiredFields(schema);

  const onSubmit = (data: formValues) => {
    let _data = removeEmptyFields(data);
    _data = setEmptyFieldsToNull(data);
    setFilterData(_data);
    onCancel();
  };

  const onClear = () => {
    form.reset({
      [CITY]: "",
      [CONTACT_NO]: "",
      [ONBOARDING_DATE]: "",
      [SCHOOL_NAME]: "",
      [STATE]: "",
    });
    setFilterData(null);
  };

  return {
    form,
    onSubmit,
    requiredFields,
    isMobile,
    onClear,
  };
};

export default useFilter;
